import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import WhatsappFloat from './components/WhatsappFloat';

import Inicio from './pages/Inicio';
import Servicios from './pages/Servicios';
import SobreNosotros from './pages/SobreNosotros';
import Contacto from './pages/Contacto';
import Login from './pages/Login';
import ClienteArea from './pages/ClienteArea';
import Configuraciones from './pages/Configuraciones';
import CambiarContraseña from './pages/CambiarContraseña';
import AdminArea from './pages/ADMINISTRADOR/AdminArea';
import SolicitudReparacion from './pages/SolicitudReparacion';

import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

import './styles.css';

function App() {
  const [user, setUser] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setCheckingStatus(false);
    });

    return () => unsubscribe();
  }, []);

  if (checkingStatus) {
    return (
      <div className="loading-spinner">
        <p>Cargando sesión...</p>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Header user={user} />

      <main className="page-wrapper">
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/servicios" element={<Servicios />} />
          <Route path="/sobre-nosotros" element={<SobreNosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/solicitar-diagnostico" element={<SolicitudReparacion />} />

          <Route
            path="/login"
            element={<Login onLogin={setUser} />}
          />

          <Route
            path="/area-cliente"
            element={
              user ? (
                <ClienteArea
                  user={user}
                  onLogout={() => auth.signOut().then(() => setUser(null))}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />

          <Route path="/configuraciones" element={<Configuraciones />}>
            <Route path="cambiar-contraseña" element={<CambiarContraseña />} />
          </Route>

          <Route
            path="/admin"
            element={
              user && user.email === 'duxbyteinformatica@gmail.com' ? (
                <AdminArea />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <WhatsappFloat />
      <Footer user={user} />
    </div>
  );
}

export default App;
